import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";
import { ShieldCheck, Truck, Package, Star } from "lucide-react";

const STAR_SLOTS = ["s1", "s2", "s3", "s4", "s5"];

export default function ProductDetail() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const [qty, setQty] = useState(1);
  const { addItem } = useCart();

  useEffect(() => {
    api.get(`/products/${id}`).then(r => { setP(r.data); setQty(r.data.moq || 1); }).catch(() => {});
  }, [id]);

  if (!p) return <div className="nx-container py-16 mono text-xs">LOADING...</div>;

  const add = () => {
    addItem(p, qty);
    toast.success(`Added ${qty} × ${p.name}`);
  };

  const isB2B = p.marketplace === "b2b";

  return (
    <div className="nx-container py-10">
      <Link to="/products" className="mono text-[11px] text-slate-500 hover:text-blue-700">← BACK/TO/CATALOG</Link>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-10">
        <div className="border border-slate-200 bg-slate-50 overflow-hidden">
          <img src={p.image} alt={p.name} className="w-full aspect-square object-cover" />
        </div>
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="mono text-[10px] text-slate-500">{p.category}</span>
            {isB2B ? (
              <span className="nx-tag text-blue-700 border-blue-700">WHOLESALE</span>
            ) : (
              <span className="nx-tag text-emerald-700 border-emerald-700">RETAIL</span>
            )}
            {p.flash_sale && <span className="nx-tag bg-[#A3E635] text-emerald-950 border-emerald-900">-{p.discount}%</span>}
          </div>
          <h1 className="text-3xl md:text-4xl font-black tracking-tighter">{p.name}</h1>
          <div className="flex items-center gap-2 mt-3">
            <div className="flex text-amber-500">
              {STAR_SLOTS.map((slot, i) => <Star key={slot} size={14} fill={i < Math.floor(p.rating) ? "currentColor" : "none"} />)}
            </div>
            <span className="text-sm text-slate-600">{p.rating} · 1.2k sold</span>
          </div>

          <div className="mt-6 py-6 border-y border-slate-200">
            <div className="flex items-baseline gap-3">
              <span className="text-5xl font-black tracking-tighter">${p.price.toFixed(2)}</span>
              <span className="mono text-xs text-slate-500">USD</span>
            </div>
            {isB2B && <p className="mono text-[11px] text-slate-500 mt-2">MIN/ORDER: {p.moq} UNITS · FOB</p>}
          </div>

          <p className="mt-6 text-slate-700 leading-relaxed">{p.description}</p>

          <div className="mt-8 flex items-center gap-3">
            <div className="flex border border-slate-900">
              <button data-testid="qty-decrease" onClick={() => setQty(Math.max(p.moq || 1, qty - 1))} className="px-3 py-2 hover:bg-slate-100">-</button>
              <input value={qty} onChange={(e) => setQty(Math.max(p.moq || 1, parseInt(e.target.value) || 1))} data-testid="qty-input" className="w-16 text-center outline-none border-x border-slate-900" />
              <button data-testid="qty-increase" onClick={() => setQty(qty + 1)} className="px-3 py-2 hover:bg-slate-100">+</button>
            </div>
            <button data-testid="add-cart-btn" onClick={add} className="flex-1 nx-btn-primary">
              Add to Cart · ${(p.price * qty).toFixed(2)}
            </button>
          </div>

          <div className="mt-8 grid grid-cols-3 gap-4 text-xs text-slate-700">
            <div className="flex flex-col gap-1 border-l-2 border-slate-900 pl-3">
              <ShieldCheck size={16} /><span className="mono text-[10px]">TRADE/ASSURANCE</span>
            </div>
            <div className="flex flex-col gap-1 border-l-2 border-slate-900 pl-3">
              <Truck size={16} /><span className="mono text-[10px]">SHIPS/GLOBALLY</span>
            </div>
            <div className="flex flex-col gap-1 border-l-2 border-slate-900 pl-3">
              <Package size={16} /><span className="mono text-[10px]">VERIFIED/QC</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
